import { useCallback } from 'react';
import { Household, TutorialPages } from '../../../../common/src/model.ts';
import * as server_api from '../../../../common/src/server_api.ts';
import { useHousehold } from '../../data/use_household.tsx';
import { useUser } from '../../data/use_user.tsx';

export function useCompleteTutorial() {
  const { setHousehold } = useHousehold();
  const { user } = useUser();

  return useCallback(
    async (tutorialPage: TutorialPages) => {
      if (!user || user.tutorialsCompleted?.includes(tutorialPage)) {
        return;
      }
      const updatedUser = {
        ...user,
        tutorialsCompleted: [...(user.tutorialsCompleted ?? []), tutorialPage],
      };
      await server_api.upsertUser(updatedUser);
      await setHousehold((household) => {
        if (!household) {
          return;
        }
        const updatedUsers = household.users.map((u) => (u.token === user.token ? updatedUser : u));
        return { ...household, users: updatedUsers } as Household;
      });
    },
    [setHousehold, user],
  );
}
